import React, { useState, useEffect, useContext } from "react";
import { useFormik } from "formik";
import axios from "axios";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import ConfirmUserDeleteModal from "./modals/ConfirmUserDeleteModal";
import AddEmployerModal from "./modals/AddEmployerModal";
import IOSSwitch from "../Settings/toggle";
import EditAsset from "./modals/editAsset";
// import AreYouSureModal from "./modals/areYouSure";
import GreenButton from "../../components/GreenButton";
import { IoAddOutline } from "react-icons/io5";
import UsageNew from "../Usage/UsageNew";
import ApiPage from "./ApiPage";
import IntegrationsPage from "./IntegrationsPage";
import AreYouSureModal from "../../components/AreYouSure";
import VanishComponent from "../../components/VanishComponent";
import { sideBarContext } from "../../App";

const Settings = () => {
  const token = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `${token}` },
  };

  const [manageUserModalOpen, setmanageUserModalOpen] = useState(false);
  // const [current, setCurrent] = useState("manageAsset");
  const [error, setError] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const [isDiabled, setIsDiabled] = useState(true);
  const [responseMsg, setResponseMsg] = useState("");

  const [userMail, setUserMail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPasswordConfirm, setUserPasswordConfirm] = useState("");

  const [isDiabledUser, setIsDiabledUser] = useState(true);

  const [list, setList] = useState([]);
  const [manageAssetList, setmanageAssetList] = useState([]);
  const [asset, setAsset] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [areYouSure, setAreYouSure] = useState("");

  const storedCurrent = "manageUser";

  const [current, setCurrent] = useState(storedCurrent);
  const { expanded } = useContext(sideBarContext);

  // const [userList, setUserList] = useState([]);

  // useEffect(() => {
  //   axios
  //     .get(`${process.env.REACT_APP_URL}/console/employer/users`, config)
  //     .then(res => {
  //       // console.log(res);
  //       setUserList(() => res.data);
  //     })
  // }, []);

  useEffect(() => {
    // console.log('inside usef')
    if (currentPassword && newPassword && newPassword === newPasswordConfirm) {
      setIsDiabled(false);
    } else setIsDiabled(true);
  }, [currentPassword, newPassword, newPasswordConfirm]);

  useEffect(() => {
    if (
      userPassword &&
      userPasswordConfirm &&
      userPassword === userPasswordConfirm
    ) {
      setIsDiabledUser(false);
    } else setIsDiabledUser(true);
  }, [userPassword, userPasswordConfirm]);

  const handleClick = (e, values) => {
    // e.preventDefault();
    // console.log('inside handleClick')
    axios
      .post(
        `${process.env.REACT_APP_URL}/console/change_password`,
        {
          current_password: formik.values.currentPassword,
          new_password: formik.values.newPassword,
          new_password_confirmation: formik.values.newPasswordConfirm,
        },
        config
      )
      .then((response) => {
        console.log(response);
        // console.log(response.data);
        setResponseMsg(response.data.message);
        if (response.status === 200) {
          setCurrentPassword("");
          setNewPassword("");
          setNewPasswordConfirm("");
        }
      });
    // .catch(err => {
    //   console.log(err)
    //   console.log(err.message)
    //   console.log(err.data)
    //   setResponseMsg(err.message);
    // })
  };

  const handleDeleteUser = async (id) => {
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "DELETE",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/console_user/${id}`,
        options
      );
      if (res.data.message === "Deleted Successfully") {
        fetchConsoleUsers();
        setAreYouSure(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
    },

    onSubmit: (e, values) => {
      console.log(formik.values);
      // handleSubmit(values, config);
      // handleFormLocalLoad();

      handleClick(e, values);
      // resetForm({ values: "" });
    },
  });

  const fetchConsoleUsers = async () => {
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/console_user`,
        options
      );
      setList(res.data.users);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchmanageAssets = async () => {
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/assets`,
        options
      );
      setmanageAssetList(res.data.lender_details);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchConsoleUsers();
    if (current === "manageAsset") {
      fetchmanageAssets();
    }
  }, []);

  const updateStatus = async (id, status, tenure, interestRate, ltv) => {
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "PUT",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/assets/${id}?status=${status}&tenure=${tenure}&interest_rate=${interestRate}&ltv=${ltv}`,
        options
      );
      if (res.data.message === "updated Successfully") {
        fetchmanageAssets();
        setShowEditModal(false);
      }
      if (res.data.status === 200) {
        setShowEditModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setCancel = () => {
    setAreYouSure("");
  };
  const setMessageError = (data) => {
    setError(data);
  };

  return (
    <div className={`employees ${!expanded && "sidebar-width"}`}>
      <div style={{ width: "100%" }}>{/* <Navbar /> */}</div>
      <div className="settings w-full h-screen">
        <div className="settings-container">
          {/* <ConfirmUserDeleteModal /> */}
          {/* <MsgModal /> */}
          <AddEmployerModal
            fetchConsoleUsers={fetchConsoleUsers}
            manageUserModalOpen={manageUserModalOpen}
            setError={setMessageError}
            handlemanageUserClose={() => setmanageUserModalOpen(false)}
          />
          <div className="settings-container-left">
            {/* <div className="container-left-wrap">
              <button
                onClick={() => {
                  setCurrent("manageAsset");
                  sessionStorage.setItem("currentSetting", "manageAsset");
                  fetchmanageAssets();
                }}
                className={current === "manageAsset" ? "active" : ""}
              >
                Manage Asset
              </button>
            </div> */}
            <div className="container-left-wrap">
              <button
                onClick={() => {
                  setCurrent("manageUser");
                  sessionStorage.setItem("currentSetting", "manageUser");
                }}
                className={current === "manageUser" ? "active" : ""}
              >
                Manage User
              </button>
            </div>
            <div className="container-left-wrap">
              <button
                onClick={() => {
                  setCurrent("usage");
                  sessionStorage.setItem("currentSetting", "usage");
                }}
                className={current === "usage" ? "active" : ""}
              >
                Usage
              </button>
            </div>
            {localStorage.getItem("lender_uuid") ===
              "08e70572-1f89-4d65-b2e1-fb38565848e1" && (
              <div className="container-left-wrap">
                <button
                  onClick={() => {
                    setCurrent("api");
                    sessionStorage.setItem("currentSetting", "api");
                  }}
                  className={current === "api" ? "active" : ""}
                >
                  API
                </button>
              </div>
            )}

            {localStorage.getItem("lender_uuid") ===
              "08e70572-1f89-4d65-b2e1-fb38565848e1" && (
              <div className="container-left-wrap">
                <button
                  onClick={() => {
                    setCurrent("integrations");
                    sessionStorage.setItem("currentSetting", "integrations");
                  }}
                  className={current === "integrations" ? "active" : ""}
                >
                  Integrations
                </button>
              </div>
            )}
          </div>
          <div className="settings-container-center"></div>
          <div className="settings-container-right">
            <div className="container-right-wrap">
              {current === "manageAsset" && (
                <div className="userlist-container">
                  <div className="userlist-table-div">
                    <table className="userlist-table">
                      <thead>
                        <tr>
                          {/* <th>Name</th> */}
                          <th>Asset</th>
                          <th>Interest Rate (%)</th>
                          <th>LTV (%)</th>
                          <th>
                            Tenure
                            <br />
                            <span style={{ fontSize: "9px" }}>(in months)</span>
                          </th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {manageAssetList?.map((asset) => {
                          return (
                            <tr key={asset.id} style={{ fontSize: "14px" }}>
                              <td>{asset.asset_name}</td>
                              <td>{asset.interest_rate}</td>
                              <td>{asset.ltv}</td>
                              <td>
                                {asset.tenure.map((t, index) => (
                                  <>
                                    {t}
                                    {index === asset.tenure.length - 1
                                      ? ""
                                      : ","}{" "}
                                  </>
                                ))}
                              </td>
                              <td>
                                <IOSSwitch
                                  checked={asset.status}
                                  onClick={() =>
                                    updateStatus(
                                      asset.id,
                                      !asset.status,
                                      asset.tenure,
                                      asset.interest_rate,
                                      asset.ltv
                                    )
                                  }
                                />
                              </td>
                              <td
                                className="edit-btn"
                                onClick={() => {
                                  setAsset(asset);
                                  setShowEditModal(true);
                                }}
                              >
                                Edit
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <EditAsset
                      showEditModal={showEditModal}
                      setShowEditModal={setShowEditModal}
                      updateStatus={updateStatus}
                      Asset={asset}
                    />
                  </div>
                </div>
              )}

              {current === "manageUser" && (
                <div className="passwordchange-container">
                  <div className="userlist-container">
                    <div className="userlist-top">
                      <h1>List of Users</h1>
                      <div onClick={() => setmanageUserModalOpen(true)}>
                        <GreenButton text={"Add user"} icon={IoAddOutline} />
                      </div>
                    </div>
                    <div className="userlist-table-div">
                      <table className="userlist-table">
                        <thead>
                          <tr>
                            {/* <th>Name</th> */}
                            <th>Email</th>
                            <th>User Type</th>
                            <th>Delete User</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list?.map((user) => {
                            return (
                              <tr key={user.id} style={{ fontSize: "14px" }}>
                                {/* <td>{user.name ? user.name : "Null"}</td> */}
                                <td>{user.email}</td>
                                <td>
                                  {user.lender_type === "admin"
                                    ? "Admin"
                                    : "Relation Manager"}
                                </td>
                                <td>
                                  <DeleteOutlineIcon
                                    onClick={() => setAreYouSure(user.id)}
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                    }}
                                    className="icon-delete"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    {/* {userList?.map(user => {
                    return (
                      <div className="userlist-div">
                        <div key={user.uuid} className="userlist-data">
                          <p>First Name: {user.first_name ? user.first_name : "Null"}</p>
                          <p>Last Name: {user.last_name ? user.last_name : "Null"}</p>
                          <p>Email: {user.email}</p>
                        </div>
                        <div className="userlist-delete">
                          <p>Delete User</p>
                        </div>
                      </div>
                    )
                  })} */}
                  </div>
                </div>
              )}
              {current === "usage" && (
                <div className="userlist-container">
                  <div className="userlist-table-div">
                    <UsageNew />
                  </div>
                </div>
              )}
              {current === "api" &&
                localStorage.getItem("lender_uuid") ===
                  "08e70572-1f89-4d65-b2e1-fb38565848e1" && (
                  <div className="userlist-container">
                    <div className="userlist-table-div">
                      <ApiPage />
                    </div>
                  </div>
                )}
              {current === "integrations" &&
                localStorage.getItem("lender_uuid") ===
                  "08e70572-1f89-4d65-b2e1-fb38565848e1" && (
                  <div className="userlist-container">
                    <div className="userlist-table-div">
                      <IntegrationsPage />
                      <EditAsset
                        showEditModal={showEditModal}
                        setShowEditModal={setShowEditModal}
                        updateStatus={updateStatus}
                        Asset={asset}
                      />
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      {
        <VanishComponent
          error={error}
          errorMessage={error}
          errorFunction={() => {
            setError("");
          }}
          timeOut={10000}
        />
      }
      {areYouSure && (
        <>
          <AreYouSureModal
            yesFunction={() => handleDeleteUser(areYouSure)}
            yes={"Delete"}
            no={"Cancel"}
            noFunction={setCancel}
          />
        </>
      )}
    </div>
  );
};

export default Settings;
